import { render } from "./AppPrayerStorm.vue?vue&type=template&id=1f6ab230"
import script from "./AppPrayerStorm.vue?vue&type=script&lang=js"
export * from "./AppPrayerStorm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__